﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class FrontendAppClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAllApps() {
        return this.client.apiFrontendappsGet();
    }
    getApp(appName) {
        return this.client.apiFrontendappsByIdGet(appName);
    }
    create(app) {
        return this.client.apiFrontendappsPost(app);
    }
    update(app) {
        return this.client.apiFrontendappsByIdPut(app.name, app);
    }
    delete(apps) {
        return this.client.apiFrontendappsDelete(apps);
    }
}
exports.FrontendAppClient = FrontendAppClient;
//# sourceMappingURL=FrontendAppClient.js.map